import React from 'react';
import { NavLink } from "react-router-dom";

const Nav = () => {
    return (
        <div className='nav'>
            <div className='wrapper flex'>
                <div className='flex'>
                    <NavLink to ='/'><img className="logo" src="/logo.png" alt="logo" /></NavLink>
                    <NavLink to ='/vendre'>Vendre</NavLink>
                    <NavLink to ='/louer'>Louer</NavLink>
                    <NavLink to ='/acheter'>Acheter</NavLink>
                </div>
                <div className='right-nav'>
                    <NavLink to ='/contact'>Nous contacter</NavLink>
                    <img className='logo-typo' src="/logotypo.png" alt='logo-typo' />
                </div>
            </div>
        </div>
    );
};

export default Nav;